import { render, staticRenderFns } from "./BadgeConfirmationDialog.vue?vue&type=template&id=73aeaf2a&scoped=true"
import script from "./BadgeConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BadgeConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./BadgeConfirmationDialog.vue?vue&type=style&index=0&id=73aeaf2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aeaf2a",
  null
  
)

export default component.exports